import { render } from "./DetailSvg.vue?vue&type=template&id=9e09282c&bindings={}"
import script from "./DetailSvg.vue?vue&type=script&lang=ts"
export * from "./DetailSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script